module.exports = __webpack_public_path__ + "img/bookmark-check-fill.330bff7a.svg";